import { render, staticRenderFns } from "./SectionFoot.vue?vue&type=template&id=17c195e1&scoped=true&"
import script from "./SectionFoot.vue?vue&type=script&lang=js&"
export * from "./SectionFoot.vue?vue&type=script&lang=js&"
import style0 from "./SectionFoot.vue?vue&type=style&index=0&id=17c195e1&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c195e1",
  null
  
)

export default component.exports